<template>
  <div class="register-success" v-if="accountStatus">
    <div class="content">
      <div class="img">
        <img src="@/assets/baibu/ic-success.png" alt="">
      </div>
      <div class="text">
        您的注册信息已提交完毕，审核通过后即可入驻成功~
      </div>
    </div>
  </div>
  <div class="account" v-else>
    <div class="title">
      {{account.supplierAccountInfo && account.supplierAccountInfo.supplierName}}
    </div>
    <van-cell-group inset>
      <van-cell 
        v-if="needPerfect"
        title="个人资料" 
        @click="perfectInfo"
      />
      <van-cell title="客服电话" :value="account.mobile||'-'" />
    </van-cell-group>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { getAccountDetail } from '@/api/baibu';

export default {
  data() {
    return {
      accountStatus: false,
      sourceTypeName: 'supplier',
      account: {
        mobile: '',
        supplierAccountInfo: {},
      },
      needPerfect: false,
    };
  },
  mounted() {
    this.accountStatus = !!this.$route.query.accountStatus;
    if (Cookies.get(`${this.sourceTypeName}_userId`)) {
      if (!this.accountStatus) {
        this.getAccount();
      }
    } else {
      this.$router.replace({
        path: '/baibu/supplier/login',
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    document.title = '';
    next();
  },
  methods: {
    getAccount() {
      getAccountDetail({
        businessType: this.sourceTypeName.toUpperCase(),
      }, {
        'req-agent': `${this.sourceTypeName}-h5`,
        'current-user-id': Cookies.get(`${this.sourceTypeName}_userId`),
      }).then((res) => {
        this.account = res.data;
        if (res.data.confirmStatus !== 'YES' || res.data.signStatus !== 'YES') {
          this.needPerfect = true;
          this.perfectInfo();
        }
        this.$nextTick();
      }).catch((error) => {
        if (error.message === '会话过期，请重新登录') {
          Cookies.remove(`${this.sourceTypeName}_userId`);
          this.$router.replace('/baibu/supplier/login');
        }
        console.log('error', error);
      });
    },
    perfectInfo() {
      window.localStorage.removeItem(`${this.sourceTypeName}AccountInfo_signContext`);
      this.$router.push({
        path: `/baibu/registration-agreement/${this.sourceTypeName}`,
        query: {
          isPerfect: 1,
        },
      });
    },
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.account {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 1.2rem 0.5rem 0 0.5rem;
  background: #f5f5f5;
  .title {
    font-size: 0.42rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }
}

.register-success {
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 1.8rem;
    font-size: 0.46rem;
    font-weight: bold;
    color: #333;
    img {
      width: 2.1rem;
      height: 2.1rem;
    }
    .text {
      padding: 0 .6rem;
      line-height: 0.6rem;
      margin-top: 0.8rem;
    }
  }
}
</style>
